import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type CreateSwiftlaneUserRequest = {
  userEmail: string
  buildingId: number
}

type CreateSwiftlaneUserResponse = {
  success: boolean
}

const createSwiftlaneUser = async (data: CreateSwiftlaneUserRequest) => {
  const response = await authAPI.post<CreateSwiftlaneUserResponse>(
    `/swiftlane/resident/${data.buildingId}`,
    { userEmail: data.userEmail },
  )
  return response.data
}

export const useCreateSwiftlaneUser = () =>
  useMutation({
    mutationFn: createSwiftlaneUser,
  })
